module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDBWMHoiIGZpbGw9Im5vbmUiLz48cGF0aCBkPSJNMjEgMTEuMDFMMyAxMXYyaDE4ek0zIDE2aDEydjJIM3pNMjEgNkgzdjIuMDFMMjEgOHoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ccpa_nav_icon.svg
// module id = ebgY
// module chunks = 2